import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./css/WhyInternWithUs.css";
const internshipData = [
  {
    title: "Internship Made Simple",
    content:
      "Discover virtual internships in Web Development, App Development, Full Stack, Machine Learning, and Data Science, all designed for focused learning.",
  },
  {
    title: "Our Commitment",
    content:
      "We are dedicated to your success, offering a trusted platform for meaningful learning experiences.",
  },
  {
    title: "Guided Skill Development",
    content:
      "Experience growth-focused internships at Yapassio, designed to maximize your skill development.",
  },
];

export default function WhyInternWithUs() {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [current, setCurrent] = useState(0);

  // Auto-slide every 3 seconds
  useEffect(() => {
    if (!isSmallScreen) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % internshipData.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [isSmallScreen]);

  const goNext = () => {
    setCurrent((prev) => (prev + 1) % internshipData.length);
  };

  const goPrev = () => {
    setCurrent((prev) => (prev === 0 ? internshipData.length - 1 : prev - 1));
  };

  const BoxCard = ({ title, content }) => (
    <div
      className="reason-box"
      style={{
        width: isSmallScreen ? "90%" : "30%",
        margin: "0 auto",
        minHeight: "300px",
        background: "#97D7E2",
        borderRadius: "30px",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <div
        style={{
          height: "60px",
          background: "white",
          border: "2px solid #97D7E2",
          borderRadius: "30px 30px 0 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "22px",
        }}
      >
        <p style={{ fontWeight: 550, margin: 0, textAlign: "center" }}>
          {title}
        </p>
      </div>
      <p
        style={{
          padding: "10%",
          fontSize: "18px",
          fontWeight: 400,
          fontFamily: "roboto",
          color: "#000",
        }}
      >
        {content}
      </p>
    </div>
  );

  return (
    <div
      style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}
    >
      {isSmallScreen ? (
        <div
          style={{ width: "100%", textAlign: "center", position: "relative" }}
        >
          <BoxCard {...internshipData[current]} />

          {/* Controls */}
          <button onClick={goPrev} className="intern-reason-arrow left">
            ❮
          </button>
          <button onClick={goNext} className="intern-reason-arrow right">
            ❯
          </button>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-around",
            alignItems: "center",
            gap: "20px",
            width: "100%",
          }}
        >
          {internshipData.map((box, index) => (
            <BoxCard {...box} key={index} />
          ))}
        </div>
      )}
    </div>
  );
}
